import { render, staticRenderFns } from "./MessageDetail.vue?vue&type=template&id=1aee0822&scoped=true"
import script from "./MessageDetail.vue?vue&type=script&lang=ts"
export * from "./MessageDetail.vue?vue&type=script&lang=ts"
import style0 from "./MessageDetail.vue?vue&type=style&index=0&id=1aee0822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aee0822",
  null
  
)

export default component.exports